import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AddContactListErrorStatus, getCheckoutCreatorStore } from '@/store/checkoutCreator/actions';
import { BasicInput, palette, Checkbox, Tooltip, ExlamationPoint } from '@dev/ee-components';
import { CreateNewListModalProps } from './types';
import { CheckboxLabelWrapper } from './styles';
import { LIST_NAME_MAX_LENGTH } from '../../constants';

export const CreateNewListModal = ({ onChangeListName, onChangeSubManagement }: CreateNewListModalProps): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [listName, setListName] = useState<string>(null);
    const [enableSubManagement, setEnableSubManagement] = useState(false);
    const { isAddListError } = useSelector(getCheckoutCreatorStore);

    useEffect(() => { onChangeListName(listName); }, [listName]);
    useEffect(() => { onChangeSubManagement(enableSubManagement); }, [enableSubManagement]);

    const handleListNameChange = (event): void => {
        const newName = event.currentTarget.value?.slice(0,LIST_NAME_MAX_LENGTH);
        setListName(newName);
        isAddListError && dispatch(AddContactListErrorStatus(false))
    };

    const handleEnableSubManagement = (e, checked): void => {
        setEnableSubManagement(checked)
    };

    return (
        <>
            <BasicInput
                id="modal-list-name-input"
                label={t('listname')}
                type="input"
                value={listName || ''}
                error={isAddListError}
                errorMessage={t('listnameexistserror')}
                onChange={handleListNameChange}
            />
            <CheckboxLabelWrapper>
                <Checkbox 
                    onChange={handleEnableSubManagement}
                    checked={enableSubManagement}
                    labelPlacement="end"
                    label={t('enableonsubscriptionmanagement')}
                />
                <Tooltip 
                    id="add-new-list-modal-checkbox" 
                    title={t('enableonsubscriptionmanagement_tooltip')}
                    PopperProps={{
                        placement: "top"
                    }}
                >
                    <ExlamationPoint color={palette.gray[4]} />
                </Tooltip>
            </CheckboxLabelWrapper>
        </>
    );
};
